import { useAxios } from '../../hooks/useAxios';

export const imageUpload = async (data) => {
  return await useAxios.post(`/board/image`, data, {
    header: { 'content-type': 'multipart/formdata' },
  });
};
